import React, { useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import emailjs from 'emailjs-com';

const Contact = () => {


  useEffect(() => {
    const navbar = document.getElementById('navbar');
    if (navbar) {
      navbar.classList.add('page');
    }
  }, []);

  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    message: ''
  });

  const [captchaValue, setCaptchaValue] = useState(null);
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!captchaValue) {
      setMessage({ text: 'Veuillez vérifier le CAPTCHA', type: 'error' });
      return;
    }

    emailjs.send("service_lkcsh9r", "template_pif87op", formData, "PLi8th08jjjpSIb-M")
      .then((result) => {
        console.log(result.text);
        setMessage({ text: 'Email envoyé avec succès', type: 'success' });
      }, (error) => {
        console.log(error.text);
        setMessage({ text: 'Erreur lors de l\'envoi de l\'email', type: 'error' });
      });
  };

  return (
    <div className="contact-form container mt-5">
        <h1>Contactez-nous</h1>
      {message.text && (
        <div className={`alert alert-${message.type === 'success' ? 'success' : 'danger'}`}>
          {message.text}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="nom" className="form-label">Nom:</label>
          <input
            type="text"
            className="form-control"
            id="nom"
            name="nom"
            value={formData.nom}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="prenom" className="form-label">Prénom:</label>
          <input
            type="text"
            className="form-control"
            id="prenom"
            name="prenom"
            value={formData.prenom}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email:</label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="message" className="form-label">Message:</label>
          <textarea
            className="form-control"
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3 d-flex justify-content-center" style={{minHeight:"80px"}}>
          <ReCAPTCHA
            sitekey="6LcYlIErAAAAADrawyVmnpX4PLrslJDRD8oOuwDP"
            onChange={handleCaptchaChange}
          />
        </div>
        <div className='text-center'>
          <button type="submit" className="btn btn-primary">Envoyer</button>
        </div>
      </form>
    </div>
  );
};

export default Contact;
